export const Videos = {
  handoversIntroVideo: require("./videos/SPRIDAKUNSKAP.SE.v3.Intro.mp4"),
  transmitInfoVideo: require("./videos/SPRIDAKUNSKAP.TransmitInfo.mp4"),
  developKnowledgeTransfer: require("./videos/DevelopKnowledgeTransfer.mp4"),
  implicitAndExplicitKnowledge: require("./videos/ImplicitAndExplicitKnowledge.mp4"),
  whatIsKnowledge: require("./videos/WhatIsKnoweledge.mp4"),
  howItWorks: require("./videos/How-does-it-works.mp4")
};
